import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, FontIcon, TextField, Chip } from 'material-ui';
import R, { equals, path, inc, dec, merge, call, cond, T, always, complement, either, isNil, isEmpty } from 'ramda';
import SaveCancel from '../tc-ui/save-cancel-buttons';
import GeneratePreview from './generate-preview';
import { browser } from 'bowser';

const isNilOrEmpty = either(isNil, isEmpty);
const isNotNilOrEmpty = complement(isNilOrEmpty);

class MediaFileDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfSelectedFiles: this.props.previewFiles.length - 1,
      isEditingFileName: false,
      showCredentialsForCloudDrive: false,
    };
  }

  getOneImage = (propToGet) => {
    return (
      call(cond([
        [equals('url'), () => {
          return (
            <div style={{ textAlign: 'center', maxHeight: '100%', maxWidth: '100%' }}>
              <GeneratePreview
                inDialog
                file={this.props.previewFiles[this.props.indexToOpen]}
                hoverEffect={false}
                showVideoControls
                minHeight="70px"
                maxHeight="700px"
                downloadOneFile={() => this.props.downloadOneFile({
                  url: this.props.previewFiles[this.props.indexToOpen].url,
                  fileName: this.props.previewFiles[this.props.indexToOpen].name,
                  fileType: this.props.previewFiles[this.props.indexToOpen].mediaType,
                })}
              />
            </div>
          );
        }],
        [equals('urlLink'), always(path([this.props.indexToOpen, 'url'], this.props.previewFiles))],
        [equals('fileName'), always(path([this.props.indexToOpen, 'name'], this.props.previewFiles))],
        [equals('index'), always(path([this.props.indexToOpen, 'index'], this.props.previewFiles))],
        [equals('fileType'), always(path([this.props.indexToOpen, 'mediaType'], this.props.previewFiles))],
        [equals('storageProvider'), always(path([this.props.indexToOpen, 'storageProvider'], this.props.previewFiles))],
        [equals('username'), always(path([this.props.indexToOpen, 'username'], this.props.previewFiles))],
        [equals('password'), always(path([this.props.indexToOpen, 'password'], this.props.previewFiles))],
        [equals('tagNames'), () => {
          const tagIds = R.pathOr([], [this.props.indexToOpen, 'tags'], this.props.previewFiles).filter(item => isNotNilOrEmpty(item));
          const findTagName = tagIds.map(eachId => {
            const tagName = this.props.MMReducer.productTags.concat(this.props.MMReducer.locationTags).filter(obj => obj.id === eachId);
            if (isNotNilOrEmpty(tagName)) return R.pluck('name')(tagName);
          });
          return findTagName.filter(item => isNotNilOrEmpty(item));
        }],
        [T, always(<span/>)],
      ]), propToGet)
    );
  };

  checkForCredentialsForCloudDrive = () => isNotNilOrEmpty(this.getOneImage('username')) || isNotNilOrEmpty(this.getOneImage('password'));

  render() {
    const {
      previewFiles, // all files to preview
      deleteFileFunc,
      closePreview,
      downloadOneFile,
      editFileNameFunc,
      isEditable,
      changeFileIndex,
      indexToOpen,
      forLocationOrProductPages,
      removeIndividualTag,
    } = this.props;
    const clearEditingState = () => this.setState({
      updatedFileName: undefined,
      isEditingFileName: false,
    });

    const onArrowClick = newIndex => {
      clearEditingState();
      changeFileIndex(newIndex);
    };

    const deleteFile = () => {
      if (equals(previewFiles.length, 1)) {
        deleteFileFunc([], previewFiles[0]);
        closePreview();
      } else {
        const removedFile = R.remove(indexToOpen, 1, previewFiles);
        deleteFileFunc(removedFile, previewFiles[indexToOpen]);
        this.setState({ numberOfSelectedFiles: dec(this.state.numberOfSelectedFiles) });
        onArrowClick(dec(indexToOpen) < 0 ? 0 : dec(indexToOpen));
      }
    };

    const deleteAndDownloadButtons = () => {
      return (
        <span className="Grid-cell Grid--1of3" style={{ textAlign: 'right' }}>
          {
            isEditable ?
              <FontIcon
                className="tc-icon-delete2"
                style={{ color: '#ff4081', marginRight: '10px', cursor: 'pointer', fontSize: '32px' }}
                onClick={() => deleteFile()}
              /> : <span/>
          }
          {
            equals(this.getOneImage('fileType'), 'CloudDrive') ?
              <span/> :
              <FontIcon
                className="tc-icon-get_app"
                style={{ color: '#00bcd4', marginRight: '10px', cursor: 'pointer', fontSize: '32px' }}
                onClick={() => downloadOneFile({
                  url: previewFiles[indexToOpen].url,
                  fileName: previewFiles[indexToOpen].name,
                  fileType: previewFiles[indexToOpen].mediaType,
                })}
              />
          }
        </span>
      );
    };

    const saveCancelButtons = () => {
      return (
        <SaveCancel
          objectInfoToMap={[
            {
              labelText: 'Cancel',
              labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
              style: { borderRadius: '3px', marginRight: '20px' },
              onTouchTap: clearEditingState,
            },
            {
              labelText: 'Save',
              style: { borderRadius: '3px' },
              onTouchTap: () => {
                const updateEditedFile = merge(previewFiles[indexToOpen], {
                  name: this.state.updatedFileName,
                });
                clearEditingState();
                editFileNameFunc(updateEditedFile);
              },
              disableSave: equals(
                this.state.updatedFileName,
                previewFiles[indexToOpen].name
              ),
            },
          ]}
        />
      );
    };

    const editingFileName = () => {
      const fileName = this.state.updatedFileName || this.getOneImage('fileName');
      const index = fileName.lastIndexOf('.');
      const fileExtension = this.getOneImage('fileName').slice(this.getOneImage('fileName').lastIndexOf('.') + 1);
      const isCloudDrive = equals(this.getOneImage('fileType'), 'CloudDrive');
      return (
        <div>
          <TextField
            inputStyle={{ fontSize: '18px', whiteSpace: 'pre-wrap', padding: '0px 3px', color: 'white' }}
            underlineShow
            rowsMax={1}
            value={(isCloudDrive || index < 0) ? fileName : fileName.slice(0, index)}
            onChange={({ target: { value } }) => this.setState({ updatedFileName: `${(isCloudDrive || index < 0) ? value : `${value}.${fileExtension}`}` })}
          />
          {saveCancelButtons()}
        </div>
      );
    };

    const actions = (
      <div className="Grid" style={{ color: 'white', fontWeight: '400', fontSize: '20px', marginTop: '16px' }}>
        <span
          className={equals(browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3'}
          style={{ width: equals(browser.name, 'Internet Explorer') ? '33%' : '' }}
        >
        </span>
        <div
          className={equals(browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3'}
          style={{ textAlign: 'center', width: equals(browser.name, 'Internet Explorer') ? '33%' : '' }}
        >
          <div>
            {
              this.state.isEditingFileName ? editingFileName() :
                <div className="Grid--center" style={{ overflow: equals(browser.name, 'Internet Explorer') ? 'hidden' : '', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                  {
                    call(cond([
                      [equals('CloudDrive'), always(
                        <a href={this.getOneImage('urlLink')} style={{ color: '#ff4081' }} target="_blank">{this.getOneImage('fileName')}</a>
                      )],
                      [complement(equals('CloudDrive')), always(this.getOneImage('fileName'))],
                    ]), this.getOneImage('fileType'))
                  }
                  <div className="edit-button hint--top" aria-label="Edit name" style={{ marginLeft: '0px' }}>
                    {
                      !this.state.isEditingFileName ?
                        <FontIcon
                          className="tc-icon-mode_edit"
                          style={{ fontSize: '24px', color: '#00bcd4', margin: equals(browser.name, 'Internet Explorer') ? '5px 0 0 10px' : '5px 0 0 20px' }}
                          onClick={() => this.setState({
                            isEditingFileName: true,
                            updatedFileName: this.getOneImage('fileName'),
                          })}
                        /> : <span/>
                    }
                  </div>
                </div>
            }
            {
              this.checkForCredentialsForCloudDrive() ?
                <div style={{ display: 'inline-block', margin: '10px 0px' }}>
                  {
                    this.state.showCredentialsForCloudDrive ?
                      <div>
                        {isNotNilOrEmpty(this.getOneImage('username')) ? <span><b>Username:</b> {this.getOneImage('username')}</span> : <span/>}
                        <br/>
                        {isNotNilOrEmpty(this.getOneImage('password')) ? <span><b>Password:</b> {this.getOneImage('password')}</span> : <span/>}
                      </div> :
                      <div
                        onClick={() => this.setState({ showCredentialsForCloudDrive: true })}
                        style={{ cursor: 'pointer', display: 'inline-block' }}
                      >
                        <b>Show Credentials</b>
                      </div>
                  }
                </div> : <span/>
            }
          </div>
        </div>
        <span className={equals(browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3'} style={{ width: equals(browser.name, 'Internet Explorer') ? '33%' : '' }}>
          {deleteAndDownloadButtons()}
        </span>
      </div>
    );

    const closePreviewIcon = (
      <div style={{ textAlign: 'right' }}>
        <FontIcon
          className="tc-icon-close22"
          style={{ color: 'white', marginRight: '48px', cursor: 'pointer', fontSize: '50px' }}
          onClick={() => closePreview()}
        />
      </div>
    );

    const imageGalleryPreview = () => {
      const showArrows = previewFiles.length > 1;
      const arrowStyle = { fontSize: '50px', cursor: 'pointer', color: 'white' };
      return (
        <div className="Grid" style={{ height: '100%' }}>
          <span className="Grid-cell Grid--1of4 Grid-cell--center">
            {
              showArrows ?
                <FontIcon
                  className="tc-icon-keyboard_arrow_left"
                  style={arrowStyle}
                  onClick={() => {
                    this.setState({ showCredentialsForCloudDrive: false });
                    onArrowClick(
                      equals(indexToOpen, 0) ?
                        this.state.numberOfSelectedFiles :
                        dec(indexToOpen)
                    );
                  }}
                /> : <span/>
            }
          </span>
          <span className="Grid-cell Grid--1of2" style={{ textAlign: 'center', flex: '0 0 80%' }}>
            {this.getOneImage('url')}
          </span>
          <span className="Grid-cell Grid--1of4 Grid-cell--center">
            {
              showArrows ?
                <FontIcon
                  className="tc-icon-keyboard_arrow_right"
                  style={arrowStyle}
                  onClick={() => {
                    this.setState({ showCredentialsForCloudDrive: false });
                    onArrowClick(
                      equals(indexToOpen, this.state.numberOfSelectedFiles) ?
                        0 : inc(indexToOpen)
                    );
                  }}
                /> : <span/>
            }
          </span>
        </div>
      );
    };

    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          position: 'fixed',
          zIndex: 1,
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          overflowX: 'hidden',
          transition: '0.5s',
          textAlign: 'center',
          paddingTop: '80px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          {closePreviewIcon}
          <div>
            {imageGalleryPreview()}
          </div>
          <div style={{ height: '150px' }}/>
        </div>
        <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '24px 0', backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
          <div style={{ color: 'white', padding: '0 3%', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
            <span style={{ fontSize: '18px' }} >{Boolean(this.getOneImage('tagNames').length) && 'Tags:'}</span>
            {this.getOneImage('tagNames').map((tag, i) => {
              return (
                <div key={i}>
                  {
                    isEditable ?
                      <Chip
                        style={{ margin: '5px', display: 'inline-block' }}
                        backgroundColor="rgb(0, 188, 212)"
                        labelColor="#ffffff"
                        labelStyle={{ verticalAlign: 'top' }}
                        onRequestDelete={() => removeIndividualTag(path([this.props.indexToOpen, 'tags', i], this.props.previewFiles))}
                      >
                        {tag}
                      </Chip> :
                      <Chip
                        style={{ margin: '5px', display: 'inline-block' }}
                        backgroundColor="rgb(0, 188, 212)"
                        labelColor="#ffffff"
                        labelStyle={{ verticalAlign: 'top' }}
                      >
                        {tag}
                      </Chip>
                  }
                </div>
              );
            })}
          </div>
          {actions}
        </div>
      </div>
    );
  }
}

MediaFileDialog.propTypes = {
  closePreview: PropTypes.func,
  previewFiles: PropTypes.array,
  deleteFileFunc: PropTypes.func,
  isEditable: PropTypes.bool,
  editFileNameFunc: PropTypes.func,
  downloadOneFile: PropTypes.func,
  indexToOpen: PropTypes.number,
  changeFileIndex: PropTypes.func,
  forLocationOrProductPages: PropTypes.bool,
  MMReducer: PropTypes.object,
  removeIndividualTag: PropTypes.func,
};

const mapStateToProps = ({ marketingMaterials, profileLocation }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
  profileLocationReducer: profileLocation.toJS(),
});

export default connect(mapStateToProps)(MediaFileDialog);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/media-file-dialog.jsx